import React from 'react';
import './Chapters.scss';

function Chapter7() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          Borsotto describes the Scale level as an enhanced version of the Deploy level. The Scale
          level sharpens the supply chain focus of the Deploy level to help partners scale across
          global regions. “Maybe they want to look at specific regional agreements—for example, they
          want to break into the Asia-Pacific region,” Borsotto explains.
        </p>
        <p className="chapter__paragraph">
          By now, both Pathr.ai and Sunlight.io have built strong businesses with solid product
          offerings. But initially, it was touch and go for retail-focused Pathr.ai; Shaw founded
          the company in 2019, just before the pandemic shuttered retail stores all over the world.
          “We managed to stay afloat through 2020,” Shaw says. And today, “We are really hitting our
          stride, really starting to grow.”
        </p>
        <p className="chapter__paragraph">
          Just as Borsotto and other Lenovo leaders behind the program intended, AI Innovators is
          helping early-stage companies like Pathr.ai and Sunlight.io thrive, with benefits accruing
          not just to them but also to Lenovo and its customers. “We want to be a significant player
          enabling AI solutions for the future,” Borsotto says. “And that doesn’t necessarily mean
          just creating our own algorithms but being a fundamental part of bringing AI to our
          customers and their customers.”
        </p>
      </section>
    </>
  );
}

export default Chapter7;
